import { clients } from 'STORE/modules/heishop/clients'
import { products } from 'STORE/modules/heishop/products'
import { inventario } from 'STORE/modules/heishop/inventario'
import { cpl } from 'STORE/modules/heishop/cpl'
import { precios } from 'STORE/modules/heishop/precios'
import { bonificaciones } from 'STORE/modules/heishop/bonificaciones' 
import { targetGroup } from 'STORE/modules/heishop/targetGroup'
import { promociones } from 'STORE/modules/heishop/promociones'
import { monitoreo } from 'STORE/modules/heishop/monitoreo'
import { historialMonitoreo } from 'STORE/modules/heishop/historialMonitoreo'


export default {
    namespaced: true,
    modules: {
        clients,
        products,
        inventario,
        cpl,
        precios,
        bonificaciones,
        targetGroup,
        promociones,
        monitoreo,
        historialMonitoreo,
    }
}